import CardAuthorBox from "components/CardAuthorBox/CardAuthorBox";
import CardAuthorBox2 from "components/CardAuthorBox2/CardAuthorBox2";
import CardSubcategoryBox from "components/CardSubcategoryBox/CardSubcategoryBox";
import Heading from "components/Heading/Heading";
import { DEMO_AUTHORS } from "data/authors";
import { AuthorType, SubcategoryType } from "data/types";
import React, { FC } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";

export interface SectionGridSubcategoriesBoxProps {
  className?: string;
  subcategoriesList?: SubcategoryType[];
  boxCard?: "box1" | "box2";
  gridClassName?: string;
}

// const DEMO_DATA = DEMO_AUTHORS.filter((_, i) => i < 10);
const DEMO_DATA: SubcategoryType[] = [];

const SectionGridSubcategoriesBox: FC<SectionGridSubcategoriesBoxProps> = ({
  className = "",
  subcategoriesList = DEMO_DATA,
  boxCard = "box1",
  gridClassName = "pl-10 pr-10 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 ",
}) => {
  return (
    <div
      className={`relative ${className}`}
    >
      <Heading desc="Explore our Sub-categories" isCenter>
        Sub-Categories
      </Heading>

      <div className={`grid gap-6 md:gap-8 ${gridClassName}`}>
        {subcategoriesList.map((subcategoryItem, index) => (
          <CardSubcategoryBox
            key={subcategoryItem.id}
            subcategory={subcategoryItem}
          />
        ))}
      </div>

      {/* <div className="mt-16 flex flex-col sm:flex-row justify-center space-y-3 sm:space-y-0 sm:space-x-5">
        <ButtonSecondary>Show me more </ButtonSecondary>
        <ButtonPrimary>Become a host</ButtonPrimary>
      </div> */}
    </div>
  );
};

export default SectionGridSubcategoriesBox;
